import { lazy } from 'react';
import type { PageRouter } from '@tools/ui/types';

const SherlockTable = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../../../pages/sherlock/genericInbox/sherlockTable'
    )
);

export const projectTaskRoutes: PageRouter[] = [
  {
    name: 'todo',
    path: '/todo',
    component: SherlockTable,
    exact: true,
    tabs: []
  },
  {
    name: 'done',
    path: '/done',
    component: SherlockTable,
    exact: true,
    tabs: []
  }
];
